<template>
  <div class="col-sm-12 col-md-4 col-lg-3">
    <div class="hero-pet-card" :class="{ roundedBotton: !showCta }">
      <div class="img-container">
        <img v-if="hero.image" :src="hero.image" :alt="hero.name">
        <img v-else src="@/assets/other/dog-outline.png" class="img-contain" :alt="hero.name">
      </div>
      <p class="name">{{ hero.name }}</p>
      <p class="medal-type">{{ hero.medal }} Medal</p>
      <p class="blood-group text-center text-primary" style="font-size:14px;">
        <span class="mr-1">
          <img src="@/assets/icon/blooddrop-red.png"
            class="img-contain"
            :alt="hero.bloodGroup"
            style="width:15px">
        </span>{{ hero.bloodGroup }}
      </p>
      <div class="help-stat">
        <img src="../assets/icon/drops.png" alt="blood drop">
        บริจาค
        <span class="float-right">{{ hero.donations }} ครั้ง</span>
      </div>
      <!-- <div class="help-stat mt-1">
        <img src="../assets/icon/heart-beat.png" alt="heart beat">
        ช่วยไป
        <span class="float-right">{{ hero.helps }} ครั้ง</span>
      </div> -->
    </div>
    <div class="hero-pet-card-cta" v-if="showCta">
      <router-link class="btn btn-link" :to="{ name: 'heroPetComment', params: {petId: hero.id} }">
        {{ hero.comments }}
        <img src="../assets/icon/comment.png" alt="heart beat">
        ร่วมชื่นชม และ ขอบคุณ
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroPetCard',
  props: ['hero', 'showCta']
}
</script>

<style scoped lang="scss">
.hero-pet-card {
  padding: 1rem 1rem 0.5rem;
  background-color: white;
  border-radius: $border-radius $border-radius 0 0;
  box-shadow: $box-shadow-sm;
  .img-container {
    width: 100%;
    padding-bottom: 100%;
    position: relative;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: $border-radius;
    }
    .img-contain {
      object-fit: contain;
    }
  }
  .name {
    margin: 0.5rem 0 0;
    line-height: 1;
    text-align: center;
  }
  .medal-type {
    margin: 0;
    font-size: $font-size-sm;
    color: $gray-600;
    text-align: center;
  }
  .help-stat {
    color: $gray-600;
    font-size: $font-size-sm;
    img {
      height: 1.25rem;
      width: 1.25rem;
      object-fit: contain;
    }
    span {
      color: $body-color;
    }
  }
  &.roundedBotton {
    border-radius: $border-radius;
    margin-bottom: 1rem;
  }
}

.hero-pet-card-cta {
  background-color: $primary;
  border-radius: 0 0 $border-radius $border-radius;
  box-shadow: $box-shadow-sm;
  margin-bottom: 1rem;
  a {
    padding: 0.5rem 1rem;
    color: white;
    text-align: center;
    width: 100%;
    font-size: $font-size-sm;
    img {
      height: 1rem;
      margin: 0 0.25rem;
    }
    &:link {
      text-decoration: none;
    }
    &:visited {
      text-decoration: none;
    }
    &:hover {
      text-decoration: none;
    }
    &:active {
      text-decoration: none;
    }
  }
}
</style>
